export const toMovie = () => {
    return {
        type: 'TO_MOVIE'
    }
}

export const toShow = () => {
    return {
        type: 'TO_SHOW'
    }
}